import addError from '../../../utils/error.jsx';

export function request(id, period, amount) {
    id = parseInt(id, 10);

    return {
        type: 'CUSTOMERS_SET_LIMIT_REQUEST',
        period,
        amount,
        id
    };
}

export function error(id, period, errors) {
    id = parseInt(id, 10);

    addError(errors);

    return {
        type: 'CUSTOMERS_SET_LIMIT_ERROR',
        errors,
        period,
        id
    };
}

export function finish(id, period, customer) {
    return {
        type: 'CUSTOMERS_SET_LIMIT_FINISH',
        customer,
        period,
        id
    };
}

export function clear() {
    return {
        type: 'CUSTOMERS_SET_LIMIT_CLEAR'
    };
}
